import {Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  shownMessage = false;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   return next
     .handle(request)
     .pipe(
       catchError((error: HttpErrorResponse) => {
         if (error.status === 401) {
           if (!this.shownMessage) {
             this.shownMessage = true;
             alert('Your session is expired');
             window.location.href = '/api/account/logout';
           }
         }

         return throwError(error);
       })
       );
  }
}
